module.exports = __webpack_public_path__ + "img/status-living.24de3376.svg";